const itemSstyle = {
  display: "flex",
  flexDirection: "column",
  border: "1px solid #ccc",
  borderRadius: "5px",
  padding: "10px",
  width: "50%",
  margin: "10px auto",
  backgroundColor: "#f9f9f9",
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
};

const priceListStyle = {
  listStyle: "none",
  display: "flex",
  gap: "15px",
};

const MassageItem = ({ item }) => {
  return (
    <div style={itemSstyle}>
      <h3 className="massage-title">{item.title}</h3>
      <p className="massage-description">{item.description}</p>
      <ul style={priceListStyle}>
        {item.price30 && (
          <li>
            <span className="bold">30 min: </span>${item.price30}
          </li>
        )}
        {item.price60 && (
          <li>
            <span className="bold">60 min: </span>${item.price60}
          </li>
        )}
        {item.price90 && (
          <li>
            <span className="bold">90 min: </span>${item.price90}
          </li>
        )}
        {item.price120 && (
          <li>
            <span className="bold">120 min: </span>${item.price120}
          </li>
        )}
      </ul>
    </div>
  );
};

export default MassageItem;
